<!-- 巡课管理 -->
<template>
<div>
    <div class="index" v-if="!detail.show&&!setting.show">
        <div class="title">
            <div class="span1">
                {{$route.name}}
            </div>
			<div class="title-right">
				<el-button size="small" style="width:100px" @click='exportFun()'>导出</el-button>
				<el-button type="primary" size="small" style="width:100px;margin-left:20px" @click='toSetting()'>巡课设置</el-button>
			</div>
			
        </div>

        <div>
			<el-form :inline="true" :model="queryParams" label-width="70px">
				<el-form-item label="学年学期">
                    <el-select v-model="queryParams.semester" clearable placeholder="请选择" class="label">
                        <el-option v-for="item in semesterList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="巡课人">
                    <el-select v-model="queryParams.user" clearable placeholder="请选择" class="label">
                        <el-option v-for="item in userList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="授课老师">
                    <el-select v-model="queryParams.teacher" clearable placeholder="请选择" class="label">
                        <el-option v-for="item in teacherList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="授课日期">
					<el-date-picker v-model="queryParams.date" type="daterange" style="width: 240px;" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" >
					</el-date-picker>
				</el-form-item>
				 <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
                </el-form-item>
			</el-form>

            <div class="table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="a" label="课程名" align="center">
                    </el-table-column>
					<el-table-column prop="b" label="授课教师" align="center">
                    </el-table-column>
                    <el-table-column prop="c" label="巡课人" align="center">
                    </el-table-column>
                    <el-table-column prop="d" label="上课时间" align="center">
                    </el-table-column>
					<el-table-column prop="e" label="巡课时间" align="center">
                    </el-table-column>
                    <el-table-column prop="f" label="上课地点" align="center">
                    </el-table-column>
                    <el-table-column prop="g" label="实到/应到学生" align="center">
                    </el-table-column>
					<el-table-column prop="h" label="巡课目标" align="center">
                    </el-table-column>
                    <el-table-column prop="i" label="巡课综合分" align="center">
                    </el-table-column>
                    <el-table-column header-align="center" align="center" label="巡课报告" fixed="right" width="150">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="toDetail(scope.row)">查看巡课报告</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
    <Edit :info.sync="detail.info" v-show="detail.show" @to-index="toIndex"></Edit>
	<Setting :info.sync="setting.info" v-show="setting.show" @to-index="toIndex"></Setting>
</div>
</template>
<script>
import api from '@/api/wisdomSchool/index.js'
export default {
    components:{
        Edit: ()=>import('./edit.vue'),
		Setting: ()=>import('./setting.vue'),
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				semester: '',
				user:'',
				date:'',
				teacher:'',
			},
			userList:[
				{id:'li',label:'李主任'}
			],
			semesterList: [
				{id:'xq1',label:'2021~2022年度下学期'},
				{id:'xq2',label:'2021~2022年度上学期'},
				{id:'xq3',label:'2020~2021年度下学期'},
				{id:'xq4',label:'2020~2021年度上学期'},
				{id:'xq5',label:'2019~2020年度下学期'},
				{id:'xq6',label:'2019~2020年度上学期'},
			],
			teacherList:[
				{id:'user1',label:'李必先'},
				{id:'user2',label:'陈正清'},
				{id:'user3',label:'林佩玲'},
				{id:'user4',label:'吴俊伯'},
				{id:'user5',label:'邓诗晗'},
				{id:'user6',label:'谢文华'},
				{id:'user7',label:'邓诗涵'},
				{id:'user8',label:'吴博俊'},
				{id:'user9',label:'朱政廷'},
				{id:'user10',label:'陈政倩'},
				{id:'user11',label:'方诗雅'},
			],
			tableData: [
				// {a:'温暖美术',b:'李必先（本校）',c:'李主任',d:'2021/11/15 15:40:22',e:'2021/11/15 15:50:42',f:'美术教室',g:'47/50',h:'教学加强月',i:'95'},
				// {a:'博学书法',b:'朱政廷（本校）',c:'李主任',d:'2021/11/17 16:50:33',e:'2021/11/15 15:50:42',f:'美术教室',g:'28/30',h:'学习习惯养成',i:'92'},
				// {a:'竞技篮球',b:'邓诗涵（本校）',c:'李主任',d:'2021/11/15 15:40:22',e:'2021/11/15 15:50:42',f:'校体育馆',g:'47/50',h:'教学加强月',i:'95'},
				// {a:'优美声乐',b:'吴博俊（本校）',c:'李主任',d:'2021/11/17 16:50:33',e:'2021/11/15 15:50:42',f:'音乐教室',g:'28/30',h:'学习习惯养成',i:'92'},
				// {a:'自信舞蹈',b:'赵鹏（本校）',c:'李主任',d:'2021/11/15 15:40:22',e:'2021/11/15 15:50:42',f:'舞蹈教室',g:'47/50',h:'教学加强月',i:'95'},
				// {a:'美学鉴赏课',b:'陈政倩（第七感官）',c:'李主任',d:'2021/11/17 16:50:33',e:'2021/11/15 15:50:42',f:'阶梯教室',g:'28/30',h:'学习习惯养成',i:'92'},
				// {a:'幸福劳动',b:'谢文华（本校）',c:'李主任',d:'2021/11/15 15:40:22',e:'2021/11/15 15:50:42',f:'三年级2班',g:'47/50',h:'教学加强月',i:'95'},
				// {a:'科技编程',b:'方诗雅（本校）',c:'李主任',d:'2021/11/17 16:50:33',e:'2021/11/15 15:50:42',f:'微机教室',g:'28/30',h:'学习习惯养成',i:'92'},
			],
            detail:{
                info:{},
                show:false,
            },
			school_info:JSON.parse(sessionStorage.getItem('classList')),
			semesterArr:JSON.parse(sessionStorage.getItem('semesterList')),
			setting:{
				info:{},
				show:false,
			},
		}
	},
	watch:{

	},
	created() {
		// this.getDataList();
	},
	methods: {
		async getDataList() {
			let params = {
				orgId:sessionStorage.getItem('orgId'),
				platformCode:sessionStorage.getItem('platformCode'),
				schoolYearSemester:this.queryParams.semester,
				campusId:this.queryParams.campus,
				classId:this.queryParams.class,
				gradeId:this.queryParams.grade,
				page:this.pageNum,
				limit:this.pageSize,
			}
			// let res = await api.studentClassStatistics(params);
			// if(res.code==='0'){
			// 	this.tableData=res.data?.list || [];
			// 	this.totalPage=res.data?.total || 0;
			// }
		},
		searchFun(){
			this.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        toDetail(item){
			this.detail.info=item;
            this.detail.show=true;
        },
        toIndex(){
            this.detail.show=false;
			this.setting.show=false;
        },
		toSetting(){
			this.setting.show=true;
		},
		exportFun(){
			
		},
	},
	mounted() {
		
	},
}
</script>
<style lang="less" scoped>
.index {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.title {
		height: 60px;
		line-height: 48px;
		border-bottom: 1px solid #eaeaea;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
		.title-right{
			height: 42px;
			padding: 5px;
			display: flex;
		}
		.span1 {
			font-family: 'PingFang SC Bold';
			font-weight: bold;
			font-size: 20px;
			text-align: left;
			color: #000;
		}
	}

	::v-deep .el-form .el-input__inner {
		width: 150px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}
}
</style>
